import { Moon, Sun } from "lucide-react";
import { cn } from "@/lib/utils";
import { useTheme } from "@/context/ThemeContext";
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from "@/components/ui/tooltip";

export function ThemeToggle({ className }: { className?: string }) {
	const { resolvedTheme, setTheme } = useTheme();
	const isDark = resolvedTheme === "dark";
	const label = isDark ? "Switch to light theme" : "Switch to dark theme";

	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<button
					type="button"
					onClick={() => setTheme(isDark ? "light" : "dark")}
					aria-label={label}
					className={cn(
						"relative flex h-9 w-9 items-center justify-center overflow-hidden rounded-md text-muted-foreground transition-colors hover:bg-muted-subtle hover:text-foreground focus:outline-none focus-visible:ring-2 focus-visible:ring-primary",
						className,
					)}
				>
					<Sun
						className={cn(
							"absolute h-4 w-4 transition-all duration-500 ease-out motion-reduce:transition-none",
							isDark
								? "-rotate-90 scale-0 opacity-0"
								: "rotate-0 scale-100 opacity-100",
						)}
					/>
					<Moon
						className={cn(
							"absolute h-4 w-4 transition-all duration-500 ease-out motion-reduce:transition-none",
							isDark
								? "rotate-0 scale-100 opacity-100"
								: "rotate-90 scale-0 opacity-0",
						)}
					/>
				</button>
			</TooltipTrigger>
			<TooltipContent>{label}</TooltipContent>
		</Tooltip>
	);
}
